export default "__VITE_ASSET__651f1eb7__"